import type { TranslationInterface } from '.';

export const GermanLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Nachricht schreiben...',
  your_issue_has_been_resolved: 'Ihr Problem wurde gelöst!',
  new_conversation: 'Neue Konversation',
  welcome_screen_title: 'Willkommen in unserem Support-Chat',
  welcome_screen_description:
    'Wir sind hier, um zu helfen! Beginnen Sie ein Gesprách und wir werden so schnell wie mogelijk antworten.',
  your_name_placeholder: 'Ihr Name',
  your_email_placeholder: 'Ihre E-Mail-Adresse',
  start_chat_button: 'Mit dem Support sprechen',
  start_chat_button_loading: 'Verbindung wird hergestellt...',
  i_need_more_help: 'Ich brauche weitere Hilfe',
  this_was_helpful: 'Dies war hilfreich',
  optional: 'Optional',
  no_conversations_yet: 'noch keine Gespräche',
  back_to_conversations: 'Zurück zur Konversationen',
  closed_conversations: 'Geschlossene Konversationen',
  csat_title: 'Wie war Ihr Gespräch?',
  csat_submitted_title: 'Sie haben das Gespräch bewertet als',
  csat_feedback_placeholder: 'Erzählen Sie uns mehr... (optional)',
  follow_up_placeholder: 'Nachfragen…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Schwebend',
  companion_layout_sidebar: 'Seitenleiste',
  companion_layout_fullscreen: 'Vollbild',
  companion_close: 'Schließen',
  companion_history: 'Gesprächsverlauf',
  companion_expand_chat: 'Chat erweitern',
  companion_sidebar_dock_label: 'Andocken',
  companion_sidebar_side_label: 'Seite',
  companion_sidebar_left: 'Links',
  companion_sidebar_right: 'Rechts',
  companion_resize_chat: 'Chatgröße ändern',
  scroll_to_bottom: 'Nach unten scrollen',
  thinking: 'Denke nach…',
  running: 'Wird ausgeführt…',
  steps: 'Schritte',
  step_arguments: 'Argumente',
  step_result: 'Ergebnis',
  attach_files:
    'Bilder, Videos, PDFs oder Tabellen anhängen (maximale Größe 25 MB)',
  mark_page_active:
    'Klicken Sie auf etwas auf der Seite, um es zu markieren — Esc zum Abbrechen',
  mark_page: 'Markieren Sie etwas auf der Seite, um danach zu fragen',
  stop_response: 'Antwort stoppen',
  copy_reply: 'Antwort kopieren',
  mentions_empty: 'Keine Treffer',
  copied: 'Kopiert',
  send_message: 'Nachricht senden',
  upload_failed: 'Upload fehlgeschlagen: {error}',
  remove_attachment: 'Anhang entfernen',
  json_no_items: 'Keine Elemente',
  json_no_data: 'Keine Daten',
  json_no_chart_data: 'Keine Daten für das Diagramm',
  json_unsupported: 'Nicht unterstützt: {type}',
  json_see_less: 'Weniger anzeigen',
  json_phone_agent: 'Telefon-Agent',
  json_phone_agent_test: 'Im Web testen',
  page_context_remove: 'Seitenkontext entfernen',
  json_see_more: '{count} weitere anzeigen',
  queued_label: '{count} In Warteschlange',
  remove_queued_message: 'Nachricht aus der Warteschlange entfernen',
  send_queued_now: 'Wartende Nachrichten jetzt senden',
  turn_failed_message:
    'Etwas ist schiefgelaufen und die Antwort ist nicht angekommen.',
  turn_failed_retry: 'Erneut versuchen',
  page_mark_hint: 'Klicken Sie auf etwas, um es zu markieren',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rahmen',
  page_mark_shape_circle: 'Kreis',
  page_mark_shape_arrow: 'Pfeil',
  page_mark_shape_bracket: 'Klammer',
  page_mark_shape_underline: 'Unterstreichen',
  page_mark_shape_highlight: 'Hervorheben',
  page_mark_shape_strike_through: 'Durchstreichen',
  page_mark_shape_crossed_off: 'Auskreuzen',
  page_mark_shape_aria: 'Markierungsform: {shape}',
  page_mark_note_placeholder: 'Notiz hinzufügen… (Enter zum Anhängen)',
  page_mark_attach: 'Markierung anhängen',
  page_mark_remove: '{label} entfernen',
  page_mark_region: 'Markierter Bereich',
  page_mark_default_message: 'Was ist das?',
  file_rejected:
    'Der Dateityp wird nicht unterstützt oder die Datei ist zu groß.',
  dictate: 'Diktieren',
  stop_dictation: 'Diktat beenden',
  dictation_mic_blocked: 'Mikrofonzugriff erlauben, um zu diktieren',
  dictation_unavailable: 'Diktieren ist derzeit nicht verfügbar',
  questions_back: 'Zurück',
  questions_next: 'Weiter',
  questions_send: 'Senden',
  questions_type_answer: 'Ich schreibe es selbst',
  questions_answer_placeholder: 'Antwort eingeben…',
  close_conversation_title: 'Konversation schließen',
  close_conversation_description:
    'Möchten Sie diese Konversation wirklich schließen?',
  close_conversation_cancel: 'Nein',
  close_conversation_confirm: 'Ja',
  dialog_close: 'Schließen',
  zoom_in: 'Vergrößern',
  zoom_out: 'Verkleinern',
  reset_zoom: 'Zoom zurücksetzen',
  support_chat_aria_label: 'Support-Chat',
};
